<template>
  <nav>
    <v-toolbar flat app>
      <v-toolbar-side-icon @click="drawer = !drawer" class="grey--text"/>
      <v-toolbar-title class="text-uppercase grey--text">
        <div>Meet Results</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="refresh()" icon>
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
  <v-navigation-drawer app v-model="drawer">
      <v-list>
        <v-list-group v-for="item in meetDates" :key="item.title"
          v-model="item.active" :prepend-icon="item.action" no-action>
          <template v-slot:activator>
             <v-list-tile>
               <v-list-tile-content>
                 <v-list-tile-title>{{ item.title }}</v-list-tile-title>
               </v-list-tile-content>
             </v-list-tile>
          </template>
          <v-list-tile v-for="subItem in item.items" :key="subItem.title">
            <v-list-tile-content>
               <router-link :to="'/results/' + subItem.title">
                 <v-list-tile-title>{{ getDate(subItem.title).toDateString() }}></v-list-tile-title>
               </router-link>
             </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
  import {bus} from '../main';
  export default {
    methods: {
      refresh() {
        bus.$emit("refresh");
      },
      getDate(val) {
        return new Date(val.substring(0,4), val.substring(4,6)-1, val.substring(6,8));
      },
    },
    data: () => ({
      drawer: false,
      fileName: "",
      meetDates: []
    }),
  created() {
    this.$http.get(`${process.env.VUE_APP_API_URL}/listdates`)
    .then(function(data) {
      const dates = data.body.sort((a,b) => this.getDate(b) - this.getDate(a));
      this.meetDates = Array.from(new Set(dates.map(date => date.substring(0,4)))).map(el => ({
        title: el,
        items: dates.filter(e => e.substring(0,4) === el)
          .map(ee => ({title: ee}))
      }));
      this.meetDates[0].active = true;
      this.$router.push(`/results/${this.meetDates[0].items[0].title}`);
    });
  },
}
</script>

<style>

</style>
